module.exports = __webpack_public_path__ + "1cc412d558fff647c1367a62f8798473.MP3";